import axios from 'axios'
import Cookies from 'js-cookie'

export const isProd =
  location.host === 'uranaitv.jp' ||
  location.host === 'zaptvpro.appspot.com' ||
  location.host === 'media.agaru.tv' ||
  location.host === 'uranai.tv'
export const isDev =
  location.host === 'zaptvtest.appspot.com' ||
  location.host === 'dev.free-fortune.jp' ||
  location.host === 'dev-media.agaru.tv' ||
  location.host === 'store-dev.agaru.tv'
export const isApp = location.host === 'zaptvapp.appspot.com' || location.host === 'dev-app.agaru.tv'
export const isLocal = !isProd && !isDev && !isApp

export const apiHost = (() => {
  if (isProd) return 'https://api.uranaitv.jp'
  if (isDev) return 'https://dev-api.uranaitv.jp'
  if (isApp) return 'https://api-dot-zaptvapp.appspot.com'

  return 'https://dev-api.uranaitv.jp'
})()

export const api = (() => {
  const API_HOST = apiHost
  const API_VERSION = API_HOST ? 'v1' : 'api'
  return axios.create({
    baseURL: `${API_HOST}/${API_VERSION}`,
    headers: {
      Authorization: `Token ${Cookies.get('auth_token')}`,
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  })
})()

export const urls = {
  VOD_VIEWS: '/program/vod_views/'
}

/**
 * API-029: VOD視聴数の登録
 * @param {string} slug 番組slug
 */
export const postVodViews = slug => {
  return api.post(`${urls.VOD_VIEWS}${slug}/`)
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/VideoPlayer/utils/api.js